
import Vue from "vue";
import Component from "vue-class-component";
import filters from "@/filters";
import { Prop, Watch } from "vue-property-decorator";
import { Action } from "vuex-class";
import toast from "@/functions/toast.function";

@Component({
  components: {},
  filters,
})
export default class MyCourseRating extends Vue {
  @Action("setRating", { namespace: "myCourse" })
  private setRating: any;

  @Prop({ default: 1 })
  private step!: number;
  @Prop({ default: 1 })
  private maxSteps!: number;
  @Prop({ default: null })
  private course!: any;
  @Prop({ default: true })
  private isLockEvaluation!: boolean;

  private rating = 5;
  private review = "";

  @Watch("course")
  private onCourse() {
    if (this.course?.rating) {
      this.rating = parseInt(this.course?.rating.rating);
      this.review = this.course?.rating.review;
    }
  }

  private get isLastStep() {
    return this.step === this.maxSteps;
  }
  private get badge() {
    switch (this.rating) {
      case 1:
        return "Poor";
      case 2:
        return "Fair";
      case 3:
        return "Good";
      case 4:
        return "Very Good";
      default:
        return "Excellent";
    }
  }

  private prev() {
    if (this.step === 1) return;
    this.$emit("nextStep", this.step - 1);
  }

  private next() {
    this.setRating({
      params: {
        id: this.course?.id,
        rating: this.rating,
        review: this.review,
      },
      success: () => {
        toast.success("Submitted.");
        if (!this.isLockEvaluation) this.$emit("nextStep", this.step + 1);
      },
    });
  }
}
